// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3vk_X","form__footer":"styles_form__footer__7Mb5p"};